module.exports = __webpack_public_path__ + "img/simpferopol.23837433.png";